import React from "react";
import "./CleanWorkSection.css";
import gifImage from "../assets/5p_cleanWork/1.gif"; // 왼쪽에 넣을 GIF 파일 경로
import pngImage from "../assets/5p_cleanWork/1.jpg";

function CleanWorkSection() {
  return (
    <section className="clean-work-section">
      {/* 왼쪽 GIF 이미지 */}
      <div className="clean-work-section-gif-container1">
        <img src={gifImage} alt="포인트 적립 안내" />
      </div>
      <div className="clean-work-section-gif-container2">
        <img src={pngImage} alt="우측 채움기획 불법 프로그램 어뷰징 미사용 문구" />
      </div>
    </section>
  );
}

export default CleanWorkSection;
